import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { PusherService } from 'src/app/services/pusher.service';

import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IonContent } from '@ionic/angular';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.page.html',
  styleUrls: ['./chat.page.scss'],
})
export class ChatPage implements OnInit {
  ticket;
  @ViewChild(IonContent) content: IonContent;
  @ViewChild('chat_input') messageInput: ElementRef;
  user;
  editorMsg = '';
  showEmojiPicker = false;
  subject;
  defaultHref = '/tecservice/home/notifications';

  constructor(
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private pusher: PusherService,
    private auth: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    if (this.router.url.indexOf('transportec') >= 0) {
      this.defaultHref = '/tecservice-transportec/wallet/notifications';
    }
    if (this.activatedRoute.snapshot.data['special']) {
      this.ticket = this.activatedRoute.snapshot.data['special'];
    } else {
      this.ticket = {
        id: this.activatedRoute.snapshot.paramMap.get('id'),
      };
    }

    this.getTicket();

    this.auth.getUser().then((user) => {
      this.user = user;
    });
  }

  getTicket() {
    this.apiService.getData('ticket/' + this.ticket.id).then((res) => {
      console.log(res);
      this.ticket = res.data;
      if (this.ticket.data) {
        const subject = JSON.parse(this.ticket.data);
        this.subject = subject.comments;
      }
      console.log(this.ticket.ticketmessages);
    });
  }

  ionViewDidEnter() {
    this.scrollToBottom();
    const channel = this.pusher.init(this.ticket.id);
    channel.bind('new-message', (data) => {
      console.log(data);
      if (data.user_id != this.user.id) {
        const newMsg = {
          user_id: data.user_id,
          ticket_id: data.ticket_id,
          created_at: Date.now(),
          message: data.message,
          status: 'success',
        };
        this.ticket.ticketmessages.push(newMsg);
        this.scrollToBottom();
      } else {
        console.log('Ignoring messages from the user itself...');
      }
    });
  }

  ionViewDidLeave() {
    this.pusher.destroy(this.ticket.id);
  }

  onFocus() {
    this.showEmojiPicker = false;
    //this.content.resize();
    this.scrollToBottom();
  }

  switchEmojiPicker() {
    this.showEmojiPicker = !this.showEmojiPicker;
    if (!this.showEmojiPicker) {
      this.focus();
    } else {
      this.setTextareaScroll();
    }
    //this.content.resize();
    this.scrollToBottom();
  }

  /**
   * @name sendMsg
   */
  sendMsg() {
    if (!this.editorMsg.trim()) return;

    // Mock message
    //const id = Date.now().toString();
    const newMsg = {
      user_id: this.user.id,
      ticket_id: this.ticket.id,
      created_at: Date.now(),
      message: this.editorMsg,
      status: 'pending',
    };

    this.pushNewMsg(newMsg);
    this.editorMsg = '';

    if (!this.showEmojiPicker) {
      this.focus();
    }
  }

  /**
   * @name pushNewMsg
   * @param msg
   */
  pushNewMsg(msg) {
    this.ticket.ticketmessages.push(msg);

    this.sendMsgToServer(msg);
    this.scrollToBottom();
  }

  sendMsgToServer(msg) {
    this.apiService.postData('ticket/' + this.ticket.id, { message: msg.message }).then((res) => {
      msg.status = 'success';
    });
  }

  getMsgIndexById(id: string) {
    return this.ticket.ticketmessages.findIndex((e) => e.messageId === id);
  }

  scrollToBottom() {
    setTimeout(() => {
      if (this.content.scrollToBottom) {
        this.content.scrollToBottom();
      }
    }, 400);
  }

  private focus() {
    if (this.messageInput && this.messageInput.nativeElement) {
      this.messageInput.nativeElement.focus();
    }
  }

  private setTextareaScroll() {
    const textarea = this.messageInput.nativeElement;
    textarea.scrollTop = textarea.scrollHeight;
  }
}
